<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editPriceTier="selectedPriceTier"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :color="$style.purchase.titlebar"
        title="Price Tier"
        @add="add"
      />

      <v-card-title>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              outlined
              prepend-inner-icon="search"
              rounded
              dense
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="PriceTiers"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left text-capitalize">{{ item.discountType }}</td>
            <td class="text-left text-capitalize">
              <span v-if="item.rate">{{ item.rate }}%</span>
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="editPriceTier(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deletePriceTier(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import PriceTierService from "@/modules/Product/PriceTier/service.js";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "PriceTier-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedPriceTier: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Discount Type",
          align: "left",
          value: "discountType",
          sortable: true,
        },
        {
          text: "Rate",
          align: "left",
          value: "rate",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      PriceTiers: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "smplsale - Price Tire List";
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      return PriceTierService.getAll().then((response) => {
        this.loading = false;
        this.PriceTiers = response.data;
        console.log(response);
        return response;
      });
    },
    editPriceTier(PriceTier) {
      this.selectedPriceTier = PriceTier;
      this.editDialog = !this.editDialog;
    },
    deletePriceTier(PriceTier) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          PriceTierService.delete(PriceTier.id).then((response) => {
            if (response.data) {
              // this.$swal("Deleted!", "PriceTier has been deleted.", "success");
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Price Tier was deleted!",
                });
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
